import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
  XMLHttpRequestHandler,
  XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { tagsView_template } from "../components/templates/tagsView_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class tags_view extends vnModule_knockoutJS {
  protected viewForm: tagsView_template;
  protected XHRHdl: XMLHttpRequestHandler;

  protected getModuleName(): string {
    return "tags_view";
  }

  buildContent(): Array<Element> {
    this.viewForm = new tagsView_template(
      "view_template",
      this.viewModel,
      this
    );

    let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
    let loadedModule = zoneHeader.loadedModule;
    (<header>loadedModule).setHeaderTitle("Tag View");

    return [this.viewForm.build()];
  }

  public fillPage(): void {
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      this.viewForm.setIdBrand(idBrand);
    }
    this.getTag();
  }

  protected getTag() {
    this.loadingIn(this.viewForm.builtTemplate);

    let idTag = this.getVnAppZone().getApp().params.idTag;

    let usrReq_url: string = "/api/tags/get/" + idTag;
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      usrReq_url = "/api/brand/" + idBrand + "/tags/get/" + idTag;
    }


    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, [], this);

    this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
    this.XHRHdl.execute();
  }

  protected onGetRequestReturn(req, obj) {
    return function () {
      obj.manageResponse(req, obj, function () {
        let responseParsed = JSON.parse(req.request.response);

        obj.viewForm.setPermissions(responseParsed.permissions);

        if (responseParsed.tag) {
          obj.setTag(responseParsed);
        }
      });

      obj.loadingOut(obj.viewForm.builtTemplate);
    };
  }

  public setTag(data): void {
    this.viewForm.setId(data.tag.id);
    this.viewForm.setName(data.tag.name);
    this.viewForm.setIdReference(data.tag.idReference);
    this.viewForm.setReferenceDescription(data.tag.referenceDescription);
    this.viewForm.setSlug(data.tag.slug);
    this.viewForm.setUrlHubPage(data.tag.urlHubPage);
    let values = [];
    let idBrand = this.getVnAppZone().getApp().params.idBrand;

    const tag = data.tag;
    const tagDefaults = tag.defaults;
    const specValues = data.specsValues;
    const specDefaults = data.specDefaults;
    this.viewForm.setIndexedValues(tag, specValues, specDefaults);

    if (tagDefaults) {
      this.viewForm.setTagDefaults(tagDefaults);
    } else {
      this.viewForm.setTagDefaults([]);
    }
    if (data.specDefaults) {
      this.viewForm.setSpecDefaults(data.specDefaults);
    } else {
      this.viewForm.setSpecDefaults([]);
    }
    if (data.specsValues) {
      values = data.specsValues;
      this.viewForm.setSpecifications(values);
    }
    if (data.tag.providerRelationships) {
      // Set providers to incoming data
      this.viewForm.setProviders(data.tag.providerRelationships);
    }

    if (data.tag.type && data.tag.type.brandOwner) {
      this.viewForm.setBrandOwner(data.tag.type.brandOwner);
    } else {
      this.viewForm.setBrandOwner(null);
    }

    if (data.tag.type) {
      this.viewForm.setTagType(
        `${data.tag.type.name} ${data.tag.type.formattedDataset}`
      );
    }
    let isSelectable = "No";
    let isActive = "No";
    if (data.tag.details) {
      this.viewForm.setTagColor(data.tag.details.color);
      this.viewForm.setTagImage(data.tag.details.image);
      this.viewForm.setTagIconImage(data.tag.details.iconImage);
      this.viewForm.setTagBannerImage(data.tag.details.bannerImage);
      this.viewForm.setTagImageGroup(data.tag.details.imageGroup);
      this.viewForm.setDescription(data.tag.details.description);
      this.viewForm.setTagVideo(data.tag.details.video);
      this.viewForm.setReviewScoreIsUnderEmbargo(data.tag.details.reviewScoreIsUnderEmbargo);
      this.viewForm.setReviewScoreEmbargoEndDate(data.tag.details.reviewScoreEmbargoEndDate);
      isSelectable = data.tag.details.isSelectable ? "Yes" : "No";
      isActive = data.tag.details.isActive ? "Yes" : "No";
      this.viewForm.setDateCreated(
        data.tag.details.dateCreated.substring(0, 10)
      );

      let shortDescription = data.tag.details.shortDescription;

      this.viewForm.setSeoDescription(shortDescription);
      this.viewForm.setReviewScore(data.tag.details.reviewScore);
      this.viewForm.setVignette(data.tag.details.vignette);
      this.viewForm.setAffiliateLinks(data.tag.details.affiliateLinks);
      this.viewForm.setProductText(data.tag.details.description);
    } else {
      this.viewForm.setSeoDescription(null);
      this.viewForm.setAffiliateLinks(null);
      this.viewForm.setProductText(null);
      this.viewForm.setTagVideo(null);
    }

    this.viewForm.setIsSelectable(isSelectable);
    this.viewForm.setIsActive(isActive);
    this.viewForm.setupCanEditThisTag();

    this.viewForm.setupUseTagDefaults(data.tag);
    this.viewForm.getTemplateViewModel().affiliateOptionsString(this.viewForm.getTemplateViewModel().buildAffiliateOptionsString());
    this.viewForm.getTemplateViewModel().setAffiliateOptionLinks();

    const isTagActive = data.tag.details ? data.tag.details.isActive : false;
    if(idBrand && !isTagActive){
      this.viewForm.toggleInactiveTagPopupVisibility();
    }
  }

  protected edit(id) {
    let url: string = "/categorization/tags/edit/" + id;
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      url = "/brand/" + idBrand + "/categorization/tags/edit/" + id;
    }

    page.redirect(url);
  }

  protected cancel() {
    let url: string = "/categorization/tags";
    let idBrand = this.getVnAppZone().getApp().params.idBrand;
    if (idBrand) {
      url = "/brand/" + idBrand + "/categorization/tags/";
    }

    page.redirect(url);
  }

  public activateTagById() {

    if (this.XHRHdl) {
        this.XHRHdl.cancelAndReset();
    }

    let usrReq_url: string = '/api/brand/' + this.vnAppZone.app.params.idBrand + "/tags/activate/" + this.getVnAppZone().getApp().params.idTag;
    let usrReq_params: Array<Array<string>> = [];


    this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
    this.XHRHdl.onReadyStateFunction = this.onActivateTagReturn;
    this.XHRHdl.execute();

  }

  protected onActivateTagReturn(req, obj) {
    return function () {
        if (req.request.status == 400 && req.request.readyState == 4) {
          obj.cancel();
        }
        obj.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);
            if(responseParsed.success){
              window.location.reload();
            }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./js/modules/tags_view.ts